import { get } from 'lodash';

/**
 * Fetches a translation according to a path
 * @param {string} path - The translation path, optionally deep: `category.translation_name`
 * @return {string} The translation found under the given path (if no translation was found, returns the given path)
 */
export default function translateFilter(path) {
    return get(globals.config.translations, path) || path;
}



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/filters/translate/index.js